<template lang="html">
	<div class="quanyiContainer">
		<div class="title">专属权益</div>
		<div class="sub-title">君子之道，洪泽天下；君子有志，弘毅宽厚。君弘财富俱乐部是由国泰君安倾心打造的证券行业第一俱乐部品牌，为高端财富人群一揽子专属全面的个性化服务及增值服务。</div>
		<div class="quanyiBox">
			<div class="box right">
				<router-link to="/surroundings">
					<div class="boxImg">
						<img src="../../assets/img/zhoubian.png">
					</div>
					<div class="boxText">
						<div class="boxTitle">限量周边</div>
						<div class="boxEngTitle">LIMITED SOUVENIRS</div>
						<div class="boxContent">
							聚焦为创业家、奋斗之家、传承之家量身定制的限量周边商品，体验财富私享礼。
						</div>
					</div>
				</router-link>
			</div>
			<div class="box left">
				<router-link to="/activityList">
					<div class="boxImg">
						<img src="../../assets/img/zhoubian.png">
					</div>
					<div class="boxText">
						<div class="boxTitle">专属活动</div>
						<div class="boxEngTitle">MEMBER ACTIVITIES</div>
						<div class="boxContent">
							涵盖“境外投资、财富传承、子女教育、公益活动”多个系列活动。为您创造良好的互动交流平台，打造优质社交圈。
						</div>
					</div>
				</router-link>
			</div>
			<div class="box right">
				<!-- <router-link to="/quanyi"> -->
					<div class="boxImg">
						<img src="../../assets/img/zengzhi.png">
					</div>
					<div class="boxText">
						<div class="boxTitle">增值服务</div>
						<div class="boxEngTitle">VALUE-ADDED SERVICES</div>
						<div class="boxContent">
							围绕商旅出行、品质生活、健康医疗、运动休闲...更多增值权益，敬请期待。
						</div>
					</div>
				<!-- </router-link> -->
			</div>
			<div class="box left">
				<!-- <router-link to="/quanyi"> -->
					<div class="boxImg">
						<img src="../../assets/img/licai.png">
					</div>
					<div class="boxText">
						<div class="boxTitle">理财空间</div>
						<div class="boxEngTitle">FINACIAL PLATFORMS</div>
						<div class="boxContent">
							营业部专设贵宾理财室、数字化功能体验区、优先业务办理通道等君弘财富会员专属服务设施。
						</div>
					</div>
				<!-- </router-link> -->
			</div>
		</div>
	</div>
</template>
<script>
	export default {
	  	name: 'quanyi',
	}
</script>
<style lang="less" scoped>
	.quanyiContainer{
		padding:0px 40px;
		width:100%;
		.title{
			width:100%;
			height:40px;
			font-size:32px;
			color:#ad8f5a;
			letter-spacing:0;
			line-height:40px;
			text-align:left;
			font-weight:bold;
		}
		.sub-title{
			margin-top:20px;
			width:100%;
			font-size:24px;
			color:#999999;
			letter-spacing:0;
			line-height:40px;
			text-align:left;
		}
		.quanyiBox{
			display:inline-block;
			margin-bottom:30px;
			.left{
				float:right;
			}
			.right{
				float:left;
			}
			.box{
				background:#f1f1f1;
				border-radius:0 0 12px 12px;
				width:48%;
				margin-top:20px;
				.boxImg{
					width:100%;
					img{
						width:100%;
					}
				}
				.boxText{
					width:100%;
					padding:30px 20px;
					color:#333333;
					text-align:left;
					.boxTitle{
						font-size:28px;
						letter-spacing:0;
						line-height:28px;
					}
					.boxEngTitle{
						font-size:24px;
						letter-spacing:1.2px;
						line-height:24px;
						margin-top:20px;
					}
					.boxContent{
						margin-top:10px;
						font-size:24px;
						letter-spacing:1.2px;
						line-height:46px;
						height:180px;
						text-overflow:ellipsis;
						overflow: hidden;
				    	display: -webkit-box;
		    			-webkit-line-clamp: 4;
		    			-webkit-box-orient: vertical;
		    			word-break:break-all;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/quanyi.vue